import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * TileBadge, the pill badge that sits on an image tile.
 *
 * CSS selector: `mobile/atoms.css` `.ds-tilebadge` (+ `--avail`).
 *
 * Doctrine: tile badges are pills, not squares (canon decision #2). The default
 * is an ink fill, because a badge on artwork is chrome asserting a fact rather
 * than a selection state.
 *
 * `avail` is the availability tint and is the one status recipe in the library
 * that mixes over `--bg-primary` instead of `transparent`, so it stays opaque
 * sitting on photographic card art. That exception lives in the CSS; nothing
 * here needs to reproduce it.
 */
const TILEBADGE_VARIANT = {
  default: null,
  avail: 'ds-tilebadge--avail',
};

export const TileBadge = React.forwardRef(function TileBadge(
  { className, variant = 'default', ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cn('ds-tilebadge', TILEBADGE_VARIANT[variant], className)} {...rest} />
  );
});

export default TileBadge;
